
        <!-- 交易流水 -->
<template>
  <!-- <vue-scroll :ops="ops" style="width:100%;min-height:95%;"> -->
  <div class="financeSetA">
    <div class="navCalss">| 出入记录</div>

    <div class="navCal">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="所有记录" name="first"></el-tab-pane>
        <el-tab-pane label="入库记录" name="second"> </el-tab-pane>
        <el-tab-pane label="出库记录" name="third"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="monewt">
      <el-form :inline="true">
        <div style="margin: 10px">
          <!-- <el-form-item>
                  <el-button @click="yesData()">昨日</el-button>
                   <el-button @click="yesDataD()">今日</el-button>
                   <el-button @click="yesDataB()">近7天</el-button>
                    <el-button @click="yesDataC()">近30天</el-button>
              </el-form-item> -->

          <el-row>
            <el-col :span="7">
              <el-form-item label="单号 :">
                <el-input
                  v-model="orderNOA"
                  style="width: 224px"
                  placeholder="输入物流单号/订单编号查询"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="下单时间:">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="getDate(value1)"
                >
                </el-date-picker>
                <el-button
                  style="margin-left: 20px"
                  @click="getStoreList('1')"
                  type="primary"
                  >查询</el-button
                >
                <!-- <el-button style="margin-left:20px" @click="exportToExcel()" type="primary" v-if="activeName=='second'||activeName=='third'" >导出Excel</el-button> -->

                <!-- <el-button @click="filedSel()">重置</el-button> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <!-- //表格 -->
    <div class="table_container">
      <el-table
        :data="orderMoney"
        border
        style="width: 100%"
        stripe
        id="printTable"
      >
        <el-table-column
          label="操作时间"
          min-width="180px"
          align="center"
          prop="operatorDate"
        >
        </el-table-column>
        <el-table-column label="状态" p min-width="80px" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 2" style="color: #d9001b">入库</div>

            <div v-else style="color: #70b603">出库</div>
          </template>
        </el-table-column>
        <el-table-column
          label="订单编号"
          prop="orderNo"
          min-width="200px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="ss" @click="getorderNo(scope.row.orderNo)">
              {{ scope.row.orderNo }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="下单时间"
          min-width="100px"
          align="center"
          prop="addDate"
        >
        </el-table-column>
        <el-table-column label="名称" min-width="200" align="center">
          <template slot-scope="scope">
            <div style="display: flex">
              <div style="flex: 8">
                <div>{{ scope.row.productName }}</div>
              </div>
              <!-- <div style="flex:4;text-align:left" v-if="scope.row.detailList.length>1">
                      <span >...等{{scope.row.productNum}}类</span>	 
                 
                  </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="物流公司"
          prop="expressCompany"
          min-width="150px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="运单号"
          prop="expressNo"
          min-width="150px"
          align="center"
        >
        </el-table-column>

        <el-table-column
          label="操作人"
          prop="operatorName"
          min-width="100px"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showG"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>您确认改变该合箱状态嘛？</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirmC()">确认</el-button>
        <el-button type="primary" @click="dialog.showG = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="600px"
      center
    >
      <div class="wrl-marign">
        <div class="wrl-hedaNa">
          <!-- <el-row >
            <span v-if="orderInfo.status==1" style="color:#D9001B">
                <el-button type="primary" @click="instorage(orderInfo)" style="width:100px">入库</el-button>
                  </span>
                    <span v-else-if="orderInfo.status==2" style="color:#F59A23">
               <el-button type="primary" @click="instorage(orderInfo)" style="width:100px">重新入库</el-button>
                <el-button type="primary" @click="outbound(orderInfo)" style="width:100px">出库</el-button>
                  </span>
               
     
      </el-row> -->
        </div>
        <div class="wel-flex">
          <div>订单号：</div>
          <div>{{ orderInfo.orderNo }}</div>
        </div>
        <div class="wel-flex">
          <div>下单时间：</div>
          <div>{{ orderInfo.addDate }}</div>
        </div>
        <div class="wel-flex">
          <div>客户名称：</div>
          <div>{{ orderInfo.userName }}</div>
        </div>
        <div class="wel-flex">
          <div>客户电话：</div>
          <div>{{ orderInfo.userTel }}</div>
        </div>
        <div class="wel-flex">
          <div>客户vip：</div>
          <div>{{ orderInfo.vipCode }}</div>
        </div>
        <div class="wel-flex">
          <div>快递公司：</div>
          <div>{{ orderInfo.expressCompany }}</div>
        </div>
        <div class="wel-flex">
          <div>快递单号：</div>
          <div>{{ orderInfo.expressNo }}</div>
          <div style="margin-left: 10px" class="bt">
            <el-button
              type="text"
              class="btn"
              :data-clipboard-text="orderInfo.expressNo"
              @click="copy"
              >复制</el-button
            >
          </div>
        </div>
        <div class="wel-flex">
          <div>订单状态：</div>
          <div>
            <span v-if="orderInfo.status == 1" style="color: #d9001b">
              待入库
            </span>
            <span v-else-if="orderInfo.status == 2" style="color: #f59a23">
              已入库
            </span>
            <span v-else-if="orderInfo.status == 3" style="color: #70b603">
              已出库
            </span>
            <span v-else-if="orderInfo.status == 4" style="color: #70b603">
              已结单
            </span>
          </div>
        </div>
        <div class="wel-flex">
          <div>合箱状态：</div>
          <div class="bt">
            <div v-if="orderInfo.isBox == 1">
              <span>合箱</span>
            </div>
            <div v-else>
              <span type="text" class="red">不合箱</span>
            </div>
          </div>

          <div style="margin-left: 10px" class="bt">
            <el-button
              type="text"
              class="btn"
              @click="getorderNoB(orderInfo.orderNo, orderInfo.isBox)"
              >修改</el-button
            >
          </div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>入库时间：</div>
          <div>{{ orderInfo.storeTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 3">
          <div>出库时间：</div>
          <div>{{ orderInfo.deliveryTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>实际尺寸：</div>
          <div>{{ orderInfo.productSize }} CBM</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>实际重量：</div>
          <div>{{ orderInfo.productWeight }} KG</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2" style="height: 20px">
          <div>最后费用：</div>
          <div>CAD {{ orderInfo.total | priceFilt }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.remark">
          <div>订单备注：</div>
          <div v-if="orderInfo.remark">{{ orderInfo.remark }}</div>
          <div v-else>无</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>用户备注：</div>
          <!-- <div>{{orderInfo.remark}}</div> -->
          <div v-if="orderInfo.userRemark">{{ orderInfo.userRemark }}</div>
          <div v-else>无</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status == 1">
          <div>预估费用：</div>
          <div>CAD {{ orderInfo.total | priceFilt }}</div>
        </div>
        <div class="wrl-productList">
          <div>商品清单</div>
          <div class="wrl-border"></div>
          <div
            class="wrl-list"
            v-for="(val, i) in orderInfo.productList"
            :key="i"
          >
            <div class="wrl-flex2">
              <div class="wrl-felx3">
                {{ i + 1 }}
              </div>
              <div class="wrl-felx4" style="margin-left: 20px">
                <div class="ellipsisB" style="-webkit-box-orient: vertical">
                  {{ val.productName }}
                </div>
                <div style="display: flex; margin-top: 5px" class="wrl-felx5">
                  <div style="flex: 1">{{ val.productNum }}件</div>
                  <div style="flex: 1; min-width: 50px">{{ val.weight }}kg</div>
                  <div style="flex: 2; min-width: 100px">
                    {{ val.productLong }}x{{ val.width }}x{{ val.height }}cm
                  </div>
                  <div style="flex: 2; color: #ec808d" v-if="val.productRemark">
                    {{ val.productRemark }}
                  </div>
                </div>
              </div>
              <div class="wrl-felx6" style="margin-left: 0px; min-width: 80px">
                <div style="color: #ec808d" v-if="val.shelves">
                  货架: {{ val.shelves }}
                </div>
              </div>
              <div
                class="wrl-felx6 cursor"
                v-if="val.productImg"
                @click="opBa(val.productImg)"
              >
                <el-image
                  style="width: 80px; height: 80px"
                  :src="val.productImg"
                  fit="contain"
                ></el-image>
              </div>
              <div class="wrl-felx6" v-else>
                <div style="width: 80px; height: 80px"></div>
              </div>
              <div
                class="wrl-felx6 cursor"
                v-if="val.productImgB"
                @click="opBa(val.productImgB)"
              >
                <el-image
                  style="width: 80px; height: 80px"
                  :src="val.productImgB"
                  fit="contain"
                ></el-image>
              </div>
              <div class="wrl-felx6" v-else>
                <div style="width: 80px; height: 80px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
  <!-- </vue-scroll> -->
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as order from "@/api/order";
// import * as other from '@/api/other'
// import * as financial from '@/api/financial'
import Draggable from "vuedraggable";
import Sortable from "sortablejs";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { axios } from "utils/";
export default {
  components: {
    Draggable,
  },
  data() {
    let dataValidate = (rule, value, callback) => {
      let that = this;
      if (value === "") {
        let text;
        if (rule.field == "bankCard") {
          text = "银行卡号";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "salePrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      orderG: "",
      isBoxG: "",
      startTime: "",
      endTime: "",
      total: 0,
      //图片头
      headers: {},
      orderInfoC: "",
      orderInfo: {
        orderNo: "",
      },
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false,
        },
        rail: {
          keepShow: true,
        },
        bar: {
          //  showDelay: 3000,
          hoverStyle: false,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "#C1C1C1", //滚动条颜色
          keepShow: true,
          size: "12px",
          opacity: 1, //滚动条透明度
        },
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      activeName: "first",
      columns: [
        { title: "订单编号", key: "orderNo" },
        { title: "下单时间", key: "addDate" },
        { title: "名称", key: "productName" },
        { title: "客户", key: "contacts" },
        { title: "联系方式", key: "tel" },
        { title: "物流公司", key: "expressCompany" },
        { title: "运单号", key: "expressNo" },
        { title: "状态", key: "status" },
      ],
      //现在时间
      NowDate: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showG: false,
      },
      DataInformation: "",
      orderNOA: "",
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      orderMoney: [
        //         {
        //     status:1,
        //     addDate:'2020-04-22',
        //     operatorDate:'2020-09-29 17:35:24',
        //     operatorName:'仓管A',
        //     orderNo:'E202004220101',
        //     transaction:'12431442121',
        //     expressCompany:'顺丰速递',
        //     expressNo:'SF191294879123',
        //     tel:'14085209527',
        //     contacts:'查尔斯雷',
        //         productName:'云腿月饼云南云腿月饼云南',
        //       productList:[
        //    {
        //      shelves:'',
        //        productName:'云腿月饼云南云腿月饼云南',
        //        id:1,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //     {
        //       shelves:'',
        //        productName:'云腿月饼云南云腿月饼云南',
        //        id:2,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //       ],
        //     type:0,
        //     amount:'5.96',
        //     balance:'0.00'
        //         },
        //              {
        //     status:2,
        //     addDate:'2020-04-22',
        //     operatorDate:'2020-09-29 17:35:24',
        //         operatorName:'仓管A',
        //     orderNo:'E202004220101',
        //     transaction:'12431442121',
        //     expressCompany:'圆通速运',
        //     expressNo:'YT023943810234',
        //     tel:'14085209527',
        //     contacts:'王二狗',
        //         productName:'茶几',
        //           productList:[
        //    {
        //      shelves:'',
        //        productName:'茶几',
        //        id:1,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //        productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //     {
        //       shelves:'',
        //        productName:'茶几',
        //        id:2,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //  ],
        //     type:0,
        //     amount:'5.96',
        //     balance:'0.00'
        //         },
        //              {
        //     operatorName:'仓管C',
        //     status:3,
        //     addDate:'2020-04-22',
        //     operatorDate:'2020-09-29 17:35:24',
        //     orderNo:'E202004220101',
        //     transaction:'12431442121',
        //       expressCompany:'中通快递',
        //     expressNo:'ZT201238920123',
        //     tel:'14085209527',
        //     contacts:'王二狗',
        //  productList:[
        //    {
        //      shelves:'',
        //        productName:'北欧沙发精品北欧沙发精品',
        //        id:1,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //     {
        //       shelves:'',
        //        productName:'北欧沙发精品北欧沙发精品',
        //        id:2,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //  ],
        //         productList:[
        //    {
        //        productName:'北欧沙发精品北欧沙发精品',
        //        id:1,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //     {
        //        productName:'北欧沙发精品北欧沙发精品',
        //        id:2,
        //        productNum:100,
        //        weight:0.7,
        //        productLong:20,
        //        width:20,
        //        height:30,
        //        productRemark:'易碎、轻放',
        //         productImg:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602309150348&di=eff39494d86ac92a28bfa1787b35cdef&imgtype=0&src=http%3A%2F%2Ft8.baidu.com%2Fit%2Fu%3D1484500186%2C1503043093%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D853'
        //    },
        //  ],
        //         productName:'北欧沙发精品北欧沙发精品',
        //     type:0,
        //     amount:'5.96',
        //     balance:'0.00'
        //         },
      ],
      optionsType: [
        {
          id: 1,
          label: "全部",
        },
        {
          id: 2,
          label: "待支付",
        },
        {
          id: 3,
          label: "待结算",
        },
        {
          id: 4,
          label: "交易关闭",
        },
        {
          id: 5,
          label: "交易成功",
        },
      ],
      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
          bankCard: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
          bankUser: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
        },
      },
      productCateList: [], //类目列表存放
      confirmDialogVisible: false,
    };
  },
  created() {
    let that = this;
    that.getStoreList();
  },
  methods: {
    affirmC() {
      console.log("s");
      let that = this;
      let isbox = "";
      if (that.isBoxG == 0) {
        isbox = 1;
      } else {
        isbox = 0;
      }
      let obj = {};
      obj.orderNo = that.orderG;
      obj.operatorId = mUtils.getStore("userinfo").adminId;
      obj.isBox = isbox;
      order.updateBox(obj).then((res) => {
        if (res.data.code == 0) {
          that.$message.success("改变成功！");

          that.dialog.showG = false;
          that.getorderNo(that.orderG);
          // that.getOrderList()
        } else {
          that.$message.error("改变失败！");
        }
      });
    },
    opBa(val) {
      window.open(val, "_blank");
    },
    getStoreList(dataA) {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      let status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 2;
      } else if (that.activeName == "third") {
        status = 3;
      }

      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: status ? status : null,
        orderNo: that.orderNOA ? that.orderNOA : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
      };

      order.getStoreList(data).then((res) => {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.length > 0 &&
              res.data.data.list.forEach(function (val, index) {
                val.operatorDate = mUtils.formatDate(
                  new Date(val.operatorTime)
                );
                val.addDate = mUtils
                  .formatDate(new Date(val.addTime))
                  .substring(0, 10);
                if (
                  val.detailList &&
                  val.detailList.length > 0 &&
                  val.detailList[0] &&
                  val.detailList[0].productName.length > 20
                ) {
                  if (val.detailList.length >= 2) {
                    val.productName =
                      val.detailList[0].productName.substring(0, 20) +
                        "...等" +
                        val.detailList && val.detailList.length + "类";
                  } else {
                    val.productName =
                      val.detailList &&
                      val.detailList[0] &&
                      val.detailList[0].productName &&
                      val.detailList[0].productName.substring(0, 20);
                  }
                } else {
                  if (val.detailList && val.detailList.length >= 2) {
                    val.productName =
                      val.detailList[0].productName +
                        "...等" +
                        val.detailList && val.detailList.length + "类";
                  } else {
                    val.productName =
                      val.detailList && val.detailList[0].productName;
                  }
                  // val.productName=val.detailList[0].productName
                }

                val.detailList &&
                  val.detailList.forEach(function (value, i) {});
              });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询列表失败");
          } else {
            that.$message.error("获取列表失败");
          }
        }
        loading.close();
      });
    },
    getDate(value1) {
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    getorderNo(val) {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        orderNo: val,
      };

      order.getOrderInfo(data).then((res) => {
        if (res.data.code == 0) {
          that.orderInfo = res.data.data;
          that.orderInfo.addDate = mUtils
            .formatDate(new Date(that.orderInfo.addTime))
            .substring(0, 16);
          that.orderInfo.storeTime = mUtils
            .formatDate(new Date(that.orderInfo.storeTime))
            .substring(0, 16);
          that.orderInfo.deliveryTime = mUtils
            .formatDate(new Date(that.orderInfo.deliveryTime))
            .substring(0, 16);
          // that.orderInfo.detailList.forEach(function(val,i){
          //      val.shelves='12321'
          // })
          that.orderInfo.productList = that.orderInfo.detailList;
          let arr = [];
          let arrB = [];
          let obj = {};
          that.orderInfo.productList.forEach(function (val, i) {
            //  val.shelves=''

            arrB = [];
            val.productImgList = [];

            if (val.pic) {
              if (val.pic.indexOf(",") != -1) {
                arr = val.pic.split(",");
                val.productImg = that.orderInfo.httpUrl + val.pic.split(",")[0];
                val.productImgB =
                  that.orderInfo.httpUrl + val.pic.split(",")[1];
                arr.forEach(function (value, index) {
                  obj = {};
                  obj.productImg = value;
                  arrB.push(obj);
                });
              } else {
                val.productImg = that.orderInfo.httpUrl + val.pic;
                obj = {};
                obj.productImg = that.orderInfo.httpUrl + val.pic;
                arrB.push(obj);
              }
            }
            val.productImgList = arrB;
          });

          that.dialog.show = true;

          that.$forceUpdate();
          loading.close();
        }
      });
    },
    copy() {
      var that = this;

      var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        // 释放内存
        that.$message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        that.$message.warning("该浏览器不支持自动复制");
        // Message({
        //   message: "该浏览器不支持自动复制",
        //   type: "warning"
        // });
        // 释放内存
        clipboard.destroy();
      });
    },
    // getOrder(val){
    //      let that=this
    //      that.orderInfo=val
    //      that.dialog.show=true
    // },
    //提交
    onsubmitB() {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      let validd;
      that.$refs.netBarForm.validate((valid) => {
        validd = valid;
        return true;
      });

      if (validd) {
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    getComputer() {
      let that = this;
    },
    instorage(value) {
      let that = this;
      that.orderInfo = value;
      that.orderInfo.productList.forEach(function (val, i) {
        val.productNumB = val.productNum;
        val.weightB = val.weight;
        val.productLongB = val.productLong;
        val.widthB = val.width;
        val.heightB = val.height;
      });
      that.dialog.showD = true;
    },
    affirm() {
      let that = this;
      that.dialog.showC = false;
      that.orderInfo.orderNo = that.orderInfoC;
    },
    edit(orderInfo) {
      let that = this;
      that.orderInfoC = orderInfo;
      that.dialog.showC = true;
    },
    outbound(orderInfo) {
      let that = this;
      that.orderInfoB = orderInfo;
      that.dialog.showB = true;
    },
    handleClick(tab, event) {
      let that = this;

      this.activeName = tab.name;
      that.paginations.page_index = 1;
      that.getStoreList();
    },

    changeDate(val) {},

    //  获取现在的时间
    getNowData() {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      other.GetNowTime().then(function (res) {
        if (res.data.code != 1) {
          let msg;
          msg = "获取现在的时间失败 !";
          that.$message.error(msg);
          return;
        } else {
          that.NowData = res.data.data;

          loading.close();
        }
      });
    },
    backA() {
      this.dialog.show = false;
      this.DataInformation = "";
    },
    getorderNoB(val, isbox) {
      this.orderG = val;
      this.isBoxG = isbox;
      this.dialog.showG = true;
    },
    chai(val) {
      this.orderInfo = val;
      this.dialog.show = true;
    },
    //返回上一个页面
    back() {
      this.$router.go(-1); //返回上一层
    },
    filedSel() {
      let that = this;
      that.startDate = "";
      that.endDate = "";
      that.orderNOA = "";
      that.valueType = 1;
      that.getStoreList();
    },

    //导出到excel
    exportToExcel() {
      let that = this;
      let orderName = "";
      let nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);
      if (that.activeName == "first") {
      } else if (that.activeName == "second") {
        orderName = "入库记录" + nowTime;
      } else if (that.activeName == "third") {
        orderName = "出库记录" + nowTime;
      } else if (that.activeName == "four") {
      }
      let fix = document
        .querySelector("#printTable")
        .querySelector(".el-table__fixed-right");
      let xlsxParam = { raw: true }; //转换成excel时，使用原始的格式
      let wb;
      if (fix) {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#printTable").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#printTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#printTable"),
          xlsxParam
        );
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream;charset=utf-8" }),
          orderName + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    //提现记录

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;

      that.paginations.page_size = page_size;

      that.getStoreList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;

      that.getStoreList();
    },
  },
};
</script>
<style  lang="less" scoped>
.financeSetA {
  margin: 20px 50px 50px 50px;

  .monewt {
    margin: 20px 0px;
    // border: 1px solid rgba(121, 121, 121, 1);
    min-height: 50px;
    min-width: 900px;
  }
}
.pagination {
  margin: 20px 0;
}
.backakdia {
  background: #dcdfe6;
  line-height: 30px;
  min-height: 30px;
}
.ss {
  cursor: pointer;
  color: #409eff;
}
.navCal {
  margin: 20px 0;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.ellipsis {
  // max-width: 150px;
  max-height: 20px;
  //  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.ellipsisB {
  max-width: 225px;
  max-height: 20px;
  //  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.wel-flex {
  display: flex;
  justify-content: left;
  align-items: center;
  margin: 10px 0;
}
.wrl-hedaNa {
  margin: 10px 0;
}
.wrl-productList {
  margin: 20px 0;
}
.wrl-border {
  height: 2px;
  margin: 20px 0;
  background-color: #d7d7d7;
}
.wrl-marign {
  margin: 0 30px;
}
.wrl-flex2 {
  display: flex;
  // margin:10px 0 ;
  justify-content: start;
  align-items: center;
  .wrl-felx4 {
    width: 700px;
  }
  .wrl-felx5 {
    max-width: 700px;
  }
  .wrl-felx6 {
    margin-left: 10px;
  }
}
.wrl-felxz {
  margin: 10px 30px;
  display: flex;
  justify-content: space-between;

  .wrl-left {
    flex: 1;
    .wrl-felxz1 {
      display: flex;
    }
  }
}
.backgroundA {
  background-image: url("../../assets/img/u69.svg");
  min-height: 80px;
  line-height: 80px;
  margin: 24% 30%;
  color: white;
  background-repeat: no-repeat;
}
.avatar {
  min-height: 80px;
  width: 80px;
}
.wlr-header {
  display: flex;

  .wlr-start {
    display: flex;
    justify-content: start;
  }
}
.inpoutTop {
  margin-top: 5px;
}
.space {
  margin: 0 5px;
}
.wrl-flex56 {
  display: flex;
  margin-right: 20px;
  justify-content: flex-end;
  font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #ec808d;
}
.wrl-flex57 {
  // width: 177px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.cursor {
  cursor: pointer;
}
</style>
<style>
.navCal .is-active {
  background-color: rgba(2, 125, 180, 1);
  color: white !important;
}
.inpout .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 30px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
/* .scrt{
         overflow-x:hidden;
         overflow-y:scroll
       } */
</style>



// WEBPACK FOOTER //
// goOutList.vue?fe5a24ce